import { initialState } from './initialState';

const action = () => initialState;

export default action;
